<template>
  <input :id="field.name"
         :name="field.name"
         :data-vv-as="field.description.replace(/\./g, '')"
         class="form-control"
         v-validate="validators"
         maxlength="9"
         :readonly="locked"
         :value="renderedValue"
         @input="input"
         @focus="focus"
         @blur="blur"
  />
</template>

<script>
import { computed, ref, watch } from "vue";

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input'],

  setup(props, { emit }) {
    const renderedValue = ref(null);
    const isEdited = ref(false);

    const input = (e) => {
      isEdited.value = true;
      emit('input', e.target.value)
    }

    const validators = computed(() => {
      return {
        required: props.required && !props.field.hide,
        length: 9,
        regex: /^[0-9*]{5}[0-9]{4}$/
      }
    })

    const unwatch = watch(() => props.value, (value) => {
      if (value && !isEdited.value) {
        renderedValue.value = value && ('*****' + value.slice(-4));
        unwatch();
      }
    })

    const focus = () => {
      if (!isEdited.value) {
        renderedValue.value = '';
      }
    }

    const blur = () => {
      if (!isEdited.value && props.value) {
        renderedValue.value = '*****' + props.value.slice(-4);
      }
    }

    return {
      renderedValue,
      validators,
      input,
      focus,
      blur,
    }
  }
}
</script>



// WEBPACK FOOTER //
// SsnRender.vue?7f2d795d